export const SET_USER_PERMISSIONS = 'SET_USER_PERMISSIONS';
export const CLEAR_USER_PERMISSIONS = 'CLEAR_USER_PERMISSIONS';
